import { PositionType, SizeType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { HitAnimation } from '../../animations/HitAnimation';

// types
//-----------------------------------------------------------------------------
export type HitEffectOptions = {
  position: PositionType;
  size?: SizeType;
  color?: number;
};

/*
    block hitting effect
*/
export class HitEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _size: SizeType;
  private readonly _color: number;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: HitEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._size = options.size ?? {};
    this._color = options.color ?? 0xffffff;
  }

  public static assets(): string[] {
    // return BlockBreakAnimation.assets();
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create animation
    const animation = new HitAnimation({ color: this._color });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      this._size,
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
